import React from 'react';
import { useStaticQuery } from 'gatsby';
import { StyledH2 } from './h2.styled';
var H2 = function H2(_ref) {
    var stringText = _ref.stringText, color = _ref.color, customStyles = _ref.customStyles;
    var _useStaticQuery = useStaticQuery("1682968089"), prismicStylesConfig = _useStaticQuery.prismicStylesConfig;
    return /*#__PURE__*/ React.createElement(StyledH2, {
        color: color,
        customStyles: customStyles,
        configStyles: prismicStylesConfig.data.h2_text_styles.text
    }, stringText);
};
export default H2;
